export interface HandbookChapter {
  id: string;
  badge: string;
  title: string;
  subtitle: string;
  content: string[];
  formula?: string;
  gameTip: string;
}

export class GameTheoryHandbook {
  public static readonly CHAPTERS: HandbookChapter[] = [
    {
      id: 'dilemma',
      badge: 'CƠ CHẾ CỐT LÕI',
      title: 'Ma Trận Quyết Định (Prisoner\'s Dilemma)',
      subtitle: 'Dọn Sạch (Hợp tác) vs Chuồn Lẹ (Bội phản) vs Đổ Lỗi (Gạt sang nhà khác)',
      content: [
        '• [DỌN SẠCH] (Cooperate): Chi phí cá nhân cao (-1 Túi rác, mất 1.5s dọn), nhưng mang lại công ích tối đa (+5 Uy tín, khu phố an lành).',
        '• [CHUỒN LẸ] (Defect): Chi phí cá nhân bằng 0 (tiết kiệm túi, chạy nhanh), nhưng đẩy toàn bộ ngoại tác tiêu cực cho xóm giềng.',
        '• [ĐÁ SANG NHÀ KHÁC] (Blame Shift): Cơ chế cơ hội rủi ro cao — nếu QTE sút thành công vào cổng nhà nuôi chó khác, bạn thoát tội; nếu sút trượt, mức phạt bóc phốt x2!',
      ],
      formula: 'Payoff(Dọn) = -C_{túi} + B_{uy tín} | Payoff(Chuồn) = 0 - P(bắt) \\times Phạt',
      gameTip: 'Mẹo: Quan sát kỹ nón tầm nhìn của Bác tổ trưởng và Camera trước khi quyết định Chuồn Lẹ!',
    },
    {
      id: 'chicken_game',
      badge: 'ĐỐI ĐẦU ĐỈNH CAO',
      title: 'Trò Chơi Con Gà (Chicken Game Vỉa Hè)',
      subtitle: 'Khi hai người dắt chó chạm mặt nhau ở khúc cua ngõ hẹp',
      content: [
        '• Khi khoảng cách giữa bạn và NPC Walker dưới 5m, cả hai con cún đều rơi vào trạng thái căng thẳng.',
        '• Ai giật dây kéo cún chạy trước: Chó sẽ sủa ầm ĩ (Bark Alert) thu hút mọi ánh nhìn của Bác tổ trưởng.',
        '• Ai đứng lỳ lại: Cún bên nào mót ruột hơn sẽ ngồi thụp xuống xả bãi ngay trước mắt đối phương!',
      ],
      formula: 'Defect + Defect = Cả hai con sủa ầm ĩ, cả ngõ bật chế độ báo động đỏ!',
      gameTip: 'Mẹo: Nhìn thanh Căng Thẳng (Stress) và Mót Ruột của cún để biết khi nào nên nhường đường.',
    },
    {
      id: 'tit_for_tat',
      badge: 'CHIẾN THUẬT LẶP LẠI',
      title: 'Ăn Miếng Trả Miếng (Tit-for-Tat Vỉa Hè)',
      subtitle: 'Trò chơi lặp lại (Repeated Game) cùng một xóm ngõ',
      content: [
        '• NPC Hàng Xóm luôn ghi nhớ hành vi của bạn trong các lượt đi dạo trước.',
        '• Nếu bạn từng dọn sạch trước mặt họ: Họ sẽ thân thiện, chào hỏi và lờ đi những sơ suất nhỏ của bạn.',
        '• Nếu bạn từng Chuồn Lẹ hoặc Đổ Lỗi bị họ bắt gặp: Lần tới chó của họ mót ruột, họ sẽ dắt thẳng tới trước cửa nhà bạn xả bãi trả đũa!',
      ],
      formula: 'Hợp tác vòng đầu -> Sao chép hành động của đối phương ở các vòng sau',
      gameTip: 'Mẹo: Luôn giữ hòa khí với NPC Tit-for-Tat để tránh bị trả thù bãi mìn trước cửa nhà!',
    },
    {
      id: 'asymmetric_info',
      badge: 'TẦM NHÌN & GÓC CHẾT',
      title: 'Thông Tin Bất Cân Xứng (Line of Sight & Paranoia)',
      subtitle: 'Chủ chó tìm góc khuất — Camera và Quán nước săn lùng',
      content: [
        '• Camera tòa nhà có nón quan sát cố định và đèn chớp đỏ báo hiệu chu kỳ quét.',
        '• Quán Trà Đá hoạt động như Radar cộng đồng 360 độ — không có góc chết trừ khi bạn đi ra ngoài bán kính nghe nhìn.',
        '• Paranoia (Độ cảnh giác): Càng nhiều bãi phân bị bỏ rơi, nón tầm nhìn của người tuần tra càng mở rộng và quét nhanh hơn.',
      ],
      formula: 'P(Bị bắt) = 1.0 (Nếu trong nón tầm nhìn và không bị tường che khuất)',
      gameTip: 'Mẹo: Tận dụng các bức tường nhà dân và ngõ cụt để che chắn góc nhìn khi cần thiết.',
    },
  ];

  public static renderHtml(): string {
    return `
      <div class="handbook-modal-card">
        <div class="handbook-header">
          <div style="display:flex; align-items:center; gap:8px;">
            <span style="font-size:24px;">🎓</span>
            <div>
              <h2 style="font-size:16px; font-weight:900; color:#ffd54f; margin:0;">SỔ TAY LÝ THUYẾT TRÒ CHƠI</h2>
              <small style="font-size:10px; color:#90a4ae;">Spatial Game Theory Vỉa Hè Hà Nội 2.0</small>
            </div>
          </div>
          <button id="btnCloseHandbook" class="btn-handbook-close">✕</button>
        </div>

        <div class="handbook-body">
          ${GameTheoryHandbook.CHAPTERS.map(
            (c) => `
            <div class="handbook-card">
              <div class="hb-badge">${c.badge}</div>
              <div class="hb-title">${c.title}</div>
              <div class="hb-subtitle">${c.subtitle}</div>
              <div class="hb-content">
                ${c.content.map((p) => `<div>${p}</div>`).join('')}
              </div>
              ${c.formula ? `<div class="hb-formula">📐 ${c.formula}</div>` : ''}
              <div class="hb-tip">💡 <strong>${c.gameTip}</strong></div>
            </div>
          `
          ).join('')}
        </div>
      </div>
    `;
  }
}
